import React, { Component } from 'react';
import { FullWidthContainer } from '../FullWidthContainer';
import { ImageLazyLoad } from '../ImageLazyLoad';
import styled from 'styled-components';
import { PrimaryButton, BasicButton } from '../Buttons';
import arrowLeft from '../../assets/images/arrow_left.png';
import arrowRight from '../../assets/images/arrow_right.png';

const BannerImage = styled.div`
  width: 100%;
  height: 80vh !important;
  object-fit: cover;
  transition: 0.7s;
  object-position: center;

  & .overlay {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
  }

  @media only screen and (max-width: 768px) {
    height: 50vh !important;
  }
  .gatsby-image-wrapper {
    position: static !important;
  }
  .imgTransition {
    transition: all 0.5s ease-in;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
  .hideImage {
    opacity: 0.8;
    position: absolute;
  }
`;

const Heading = styled.h1`
  color: white;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.56);
  font-weight: bold;
  text-align: left;
  z-index: 2;
  font-size: 4em;
  font-family: AvenirBold;
  @media only screen and (max-width: 768px) {
    text-align: center;
  }
  @media only screen and (max-width: 576px) {
    font-size: 2.3em;
  }
`;

const HeadingDiv = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 13px;
  height: max-content;
  z-index: 9;
`;
const BottomNavBar = styled.div`
  position: absolute;
  bottom: 1%;
  left: 5%;
  right: 5%;
  padding: 1%;
  display: flex;
  align-items: center;
`;
const Count = styled.span`
  color: white;
  padding: 1%;
  font-weight: bolder;
`;
const ProgressBarStyled = styled.div`
  flex-grow: 2;
  padding: 1%;
`;

const Arrow = styled.span`
  color: whitesmoke;
  display: flex;
  justify-content: space-around;
  width: 80px;
  margin: 20px 0;
`;

const ArrowImage = styled.img`
  padding: 0 2px;
  width: 32px;
  height: 32px;
  filter: brightness(0) invert(1);
`;

const ArrowContainer = styled.div`
  margin: 0 2px
  &:active {
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    color: red;
  }
`;

const FullWidthContainerWrapper = styled.div`
  padding: 20px 0;
  margin: 20px 0;
  width: 100vw;
  position: relative;
  padding: ${props => props.padding};
  height: 100%;
  display: none;
  img {
    height: 100%;
    width: 100%;
    max-height: 100vh;
  }
  .imageWrapper {
    height: 100%;
  }

  @media (max-width: 567px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const SubText = styled.p`
  color: white;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.56);
  font-size: 18px;
  text-align: center;
  z-index: 2;
  opacity: 1;
  font-family: Avenir;
`;

const NameText = styled.p`
  color: white;
  font-size: 26px;
  text-align: center;
  z-index: 2;
  opacity: 1;
  font-family: AvenirMedium;
`;

const ButtonDiv = styled.div`
  @media only screen and (max-width: 576px) {
    width: max-content;
    margin: auto;
    outline: none;
    a {
      text-decoration: none;
    }
  }
  :hover {
    cursor: pointer;
  }
`;

class MobileParallex extends Component {
  constructor(props) {
    super(props);
    this.state = { index: 0, count: 0 };
  }

  componentDidMount() {
    this.setState({
      count: this.props.data.length
    });

    // setInterval(() => {
    //   const { index, count } = this.state;
    //   this.setState({
    //     index: index < count - 1 ? index + 1 : 0,
    //     progressPercent: 0
    //   });
    // }, 3000);
  }

  handlePrevious = () => {
    var { count, index: currentIndex } = this.state;
    if (currentIndex > 0) {
      currentIndex = currentIndex - 1;
    } else {
      currentIndex = count - 1;
    }
    this.setState({ index: currentIndex });
  };

  handleNext = () => {
    var { count, index: currentIndex } = this.state;
    if (currentIndex !== count - 1) {
      currentIndex = currentIndex + 1;
    } else {
      currentIndex = 0;
    }
    this.setState({ index: currentIndex });
  };
  render() {
    var { count, index } = this.state;
    let current = this.props.data[index];
    var showOrHideImage = 'hideImage';
    return (
      <FullWidthContainerWrapper classNam='d-sm-none my-4'>
        <HeadingDiv>
          <Heading>{current.text}</Heading>
          {current.name && <NameText>{current.name}</NameText>}
          <SubText
            dangerouslySetInnerHTML={{
              __html: current.subText ? current.subText : ''
            }}
          />
          {current.buttonText && current.to && (
            <ButtonDiv>
              <a href={current.to} target='_blank'>
                <BasicButton
                  text={current.buttonText}
                  invert
                  textColor={'#fff'}
                  style={{ width: 'max-content' }}
                />
              </a>
            </ButtonDiv>
          )}
          {this.props.data.length > 1 && (
            <Arrow>
              <ArrowContainer onClick={this.handlePrevious}>
                <ArrowImage src={arrowLeft} />
              </ArrowContainer>
              <ArrowContainer onClick={this.handleNext}>
                <ArrowImage src={arrowRight} />
              </ArrowContainer>
            </Arrow>
          )}
        </HeadingDiv>
        <BannerImage>
          {this.props.data.map((item, tempIndex) => {
            return (
              <div
                key={tempIndex}
                className={
                  'imgTransition ' +
                  (index === tempIndex ? '' : showOrHideImage)
                }>
                <ImageLazyLoad src={item.url} />
              </div>
            );
          })}
          <div className='overlay' />
        </BannerImage>
        {/* <BottomNavBar> */}
        {/* <Count>
            {index + 1} / {count}
          </Count> */}

        {/* </BottomNavBar> */}
      </FullWidthContainerWrapper>
    );
  }
}
export { MobileParallex };
